import templateUrl from "./command-counsellor-groups-list.html";

import "../command-counsellor-groups.scss";

export const CommandCounsellorGroupsListComponent = {
  bindings: {
    details: "<"
  },
  templateUrl,

  controller: class CommandCounsellorGroupsListComponent {
    constructor($state, toastr, ModalService, CommandCounsellorGroupsService) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.modalService = ModalService;
      this.CommandCounsellorGroupsService = CommandCounsellorGroupsService;
    }
    $onInit() {
      this.tmDetails = this.modifyCommandCounsellorsList(this.details);
    }

    onSearchGroups(value) {
      return this.searchGroupsList(value);
    }

    onEdit(event) {
      this.$state.go("commandCounsellorGroupsEdit", { group_id: event.group_id })
    }
    viewDetails(details) {
      this.$state.go('commandCounsellorGroupsDetails', { group_id: details.group_id });
    }
    onGroupAdd() {
      this.$state.go("commandCounsellorGroupsAdd")
    }
    modifyCommandCounsellorsList(allTmGroups) {
      return {
        data: allTmGroups,
        feature: "Command Career Counselor Groups",
        config: {

          columnDefs: [
            {
              field: "display_name",
              enableSort: false,
              displayName: "NAME OF GROUP",
              className: "col-lg-2 col-md-2 col-sm-3 text-break",
            },
            {
              field: "unit_identification_code",
              enableSort: false,
              displayName: "UNIT IDENTIFICATION CODE",
              className: "col-lg-3 col-md-3 col-sm-4 text-break",
            },
            {
              type: "date",
              field: "created_at",
              enableSort: true,
              format: "MM/dd/yyyy",
              displayName: "CREATED ON",
              rowClass: "text-capitalize",
              className: "col-lg-2 col-md-2 col-sm-2",
            },

            {
              field: "transition_manager_count",
              enableSort: false,
              displayName: "TRANSITION MANAGERS",
              className: "col-lg-3 col-md-3 col-sm-3 text-break",
            },
            {
              type: "Delete",
              field: "delete",
              enableSort: false,
            },
            {
              type: "View",
              field: "view",
              enableSort: false,
            },
          ],
        },
      };
    }
    onDelete(data) {
      const bodyMsg = "Are you sure to delete Group?";
      this.modalService.open({
        details: {
          bodyMessage: bodyMsg,
        },
        buttons: [
          {
            name: "No",
            action() { },
          },
          {
            name: "Yes",
            isPrimary: true,
            action: _onDelete.bind(this, data),
          },
        ],
      });
      function _onDelete(data) {
        this.CommandCounsellorGroupsService.deleteGroup(data.group_id)
          .then((_) => {

            this.toastr.success("Group deleted successfully!!");
            this.$state.reload();
          })
          .catch((err) => {
            this.toastr.error(err);
          });
      }
    }

    searchGroupsList(searchVal) {
      if (this.details) {
        // this.result = this.details.filter(o => o.display_name.includes(searchVal));
        this.result = this.details.filter(({ display_name }) => new RegExp(searchVal, 'i').test(display_name))
        this.tmDetails.data = this.result;
      }
    }

  },
};



// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-groups/command-counsellor-groups-list/command-counsellor-groups-list.component.js